import V3CoalesceAdapter from './v3-coalesce';

export default class PhotoPageAdapter extends V3CoalesceAdapter {
  pathForType() {
    return 'photo-pages';
  }
}
